import React from 'react';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';
import Button from '../../componentsV2/Button/Button';

const DownloadPage = () => {
  const breadcrumbLinks = [
    { href: '/', name: 'Home' },
    { href: '/download', name: 'Download' },
  ];

  const handleAndroidClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.vamosoutreach', '_blank');
  };

  const handleIOSClick = () => {
    window.open('https://apps.apple.com/us/app/vamos-outreach/id1480705534', '_blank');
  };

  return (
    <PageLayout
      pageTitle="Download"
      breadcrumbLinks={breadcrumbLinks}
      shouldShowBreadcrumbs
    >
      <div className="my-4 pl-2">
        Download the Vamos mobile app to map routes and log visit details while you&apos;re on the road.
      </div>

      <Button
        label="Download for Android"
        onClick={handleAndroidClick}
        className="mb-4 ml-2"
        color="action"
        aria-label="Download for Android"
      />

      <Button
        label="Download for iOS"
        onClick={handleIOSClick}
        className="mb-4 ml-2"
        color="action"
        aria-label="Download for iOS"
      />
    </PageLayout>
  );
};

export default DownloadPage;
